// Perf datapoints for compose email
export const COMPOSE_MAIL_SENT = 'ComposeMailSent';
export const COMPOSE_MAIL_DRAFT_SAVED = 'ComposeMailDraftSaved';
export const MAIL_SEND_BUTTON_CLICKED = 'MailSendButtonClicked';
export const DELETE_DRAFT_BUTTON_CLICKED = 'DeleteDraftButtonClicked';
export const DISCARD_COMPOSE_BUTTON_CLICKED = 'SoftbackButton';
export const COMPOSE_MAIL_DISCARDED = 'ComposeMailDiscarded';
export const FULL_COMPOSE_RENDERED = 'FullComposeRendered';
export const COMPOSE_MAIL_FAILED = 'ComposeMailFailed';
export const FULL_COMPOSE = 'FullCompose';

// Moved from compose package
export const EXPAND_TO_FULL_COMPOSE = 'ExpandToFullCompose';
export const EDIT_RECIPIENTS_CLICKED = 'EditRecipientsClicked';
export const EXPAND_QUICK_COMPOSE = 'OpenQuickCompose';
export const SUGGESTED_REPLY_CLICKED = 'SuggestedReplyClicked';
export const QUICK_COMPOSE_OPTIONS_CLICKED = 'QuickComposeOptionsClicked';
export const MAIL_COMPOSE_FORWARD = 'MailComposeForward';
export const MAIL_COMPOSE_REPLY = 'MailComposeReply';
export const MAIL_COMPOSE_REPLY_ALL = 'MailComposeReplyAll';
export const QUICK_COMPOSE_EXPANDED = 'QuickComposeExpanded';
export const QUICK_COMPOSE_COLLAPSED = 'QuickComposeCollapsed';
export const QUICK_COMPOSE_ATTACH_FILE_BUTTON_CLICKED = 'QuickComposeAttachFileButtonClicked';
export const QUICK_COMPOSE = 'QuickCompose';
export const EDITOR_CLICKED = 'EditorClicked';
export const VIEW_STATE_CREATED = 'ViewStateCreated';

//Moved from subject package
export const SUBJECT_CLICKED = 'SubjectClicked';

// Vernacular Compose
export const MVC_MOUNTED = 'MVC_Mounted';
export const MVC_USER_DICTATED_CONTENT = 'MVC_UserDictatedContent';
export const VERNACULAR_TRANSLATION_FEEDBACK = 'VernacularTranslationFeedback';
export const VERNACULAR_TRANSLITERATION_FEEDBACK = 'VernacularTransliterationFeedback';
export const VERNACULAR_READ_FEEDBACK = 'VernacularReadFeedback';
export const VERNACULAR_VOICE_TYPING_FEEDBACK = 'VernacularVoiceTypingFeedback';
